'use client';
import styled from 'styled-components';

export const BoldText = styled.span`
  color: ${props =>
    props.theme.colors.get(props.color, props.theme.colors.text.secondary)};
  ${props => props.theme.typography.bodyBold}
`;

export const PromoCodeContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
`;

export const OfferCodeContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: ${props => props.theme.spacing(2)};
`;

export const OfferCodeLabel = styled.p`
  ${props => props.theme.typography.subheading2};
  color: ${props => props.theme.colors.status.successPrimary};
  margin-bottom: ${props => props.theme.spacing(2)};
  overflow-wrap: break-word;
`;

export const GWPFreeItemLabel = styled.dt`
  background-color: ${props =>
    props.theme.colors.get(
      props.backgroundColor,
      props.theme.colors.background.lightest,
    )};
  border-radius: ${props => props.theme.spacing(2, 0, 0, 2)};
  color: ${props =>
    props.theme.colors.get(props.color, props.theme.colors.text.secondary)};
  min-width: 270px;
  span {
    display: flex;
    max-width: 260px;
    align-items: center;
    padding-left: ${props => props.theme.spacing(2)};
  }
  img {
    max-width: 60px;
    margin-right: ${props => props.theme.spacing(2)};
  }
`;

export const GWPFreeItemValue = styled.dd`
  display: flex;
  background-color: ${props =>
    props.theme.colors.get(
      props.backgroundColor,
      props.theme.colors.background.lightest,
    )};
  border-radius: ${props => props.theme.spacing(0, 2, 2, 0)};
  text-align: right;
  max-width: 50px;
  align-items: center;
  padding: ${props => props.theme.spacing(0, 2)};
`;
